import { useState } from 'react';
import { PricingRepositoryImpl } from '../services/PricingRepositoryImpl';
import { PricingData } from '../../entities/model/PricingData';
import { PricingRequestDTO } from '../../frameworks_drivers/dtos/PricingRequestDTO';

export const useFetchPrices = (
  repository: PricingRepositoryImpl,
  pricingRequestDTO: PricingRequestDTO
) => {
  const [pricingData, setPricingData] = useState<PricingData | undefined>();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const fetchPrices = async () => {
    try {
      setIsLoading(true);
      setIsError(false);
      setError(null);

      const data = await repository.getPricingData(pricingRequestDTO);
      setPricingData(data);
    } catch (err) {
      setIsError(true);
      setError(err instanceof Error ? err : new Error('Ein unbekannter Fehler ist aufgetreten'));
      setPricingData(pricingData);
    } finally {
      setIsLoading(false);
    }
  };

  return { pricingData, isLoading, isError, error, fetchPrices: fetchPrices };
};
